/** Dev-only (player1): realistic-looking usernames for Honor Hall mock rankings. */
export const HONOR_HALL_DEV_MOCK_PLAYER_NAMES = Object.freeze([
  'MarcusVale',
  'ElenaKross',
  'JakeMorris92',
  'PriyaShah',
  'TomBrennan',
  'NinaLarsson',
  'RyanColeman',
  'SophieDuval',
  'AndreiPetrov',
  'MayaChen',
  'ChrisNolan88',
  'LauraWhitmore',
  'DevonHayes',
  'YukiTanaka',
  'OmarHassan',
  'KateMorrison',
  'FelixBrandt',
  'AmiraJones',
  'LucasFernandez',
  'HannahBrooks',
]);
